import { Pipe, PipeTransform } from '@angular/core';

/**
 * Bolds the beginning of the matching string in the item
 */
@Pipe({
	name: 'boldprefix'
})
export class BoldPrefix implements PipeTransform {
	transform(value: string, keyword: string): any {
		if (!keyword || keyword.length < 3) {
			return value;
		}
		if (!value) {
			return value;
		}

		let escaped_keyword = keyword.replace(
			/[.*+?^${}()|[\]\\]/g,
			'\\$&'
		);

		return value.replace(
			new RegExp(
				escaped_keyword,
				'gi'
			),
			function (str) {
				return str.bold();
			}
		);
	}
}